import { render, staticRenderFns } from "./CoursesCount.vue?vue&type=template&id=96aa68a2&"
import script from "./CoursesCount.vue?vue&type=script&lang=js&"
export * from "./CoursesCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports